import { render, staticRenderFns } from "./HealthDashboard.vue?vue&type=template&id=080b6242&scoped=true"
import script from "./HealthDashboard.vue?vue&type=script&lang=js"
export * from "./HealthDashboard.vue?vue&type=script&lang=js"
import style0 from "./HealthDashboard.vue?vue&type=style&index=0&id=080b6242&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b6242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080b6242')) {
      api.createRecord('080b6242', component.options)
    } else {
      api.reload('080b6242', component.options)
    }
    module.hot.accept("./HealthDashboard.vue?vue&type=template&id=080b6242&scoped=true", function () {
      api.rerender('080b6242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/HealthDashboard.vue"
export default component.exports